import { GDFHotPolyRecordNormal } from '../../gdf/type';
import { getCopyButtonComponent } from '../copy-button';

export default function TfrProperties({ record }: { record: GDFHotPolyRecordNormal }) {
    const Button = getCopyButtonComponent();
    return (
        <div>
            <div>TFR / NOTAM ID: {record.label}</div>
            {Button && (
                <div className="d-flex justify-content-start">
                    <Button getText={() => record.detail} />
                </div>
            )}
            <div className="pt-2">Details</div>
            <div className="secondary-bg-color p-2 " style={{ fontFamily: 'monospace' }}>
                {record.detail}
            </div>
        </div>
    );
}
